import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import Rectangle from "../../../../source/js/shared/models/Geometry/Rectangle";
import { ShapeCategory } from '@/types/shapeCategories';
import { ValidatorInterface } from '../Validators/ValidatorInterface';
import AbstractShape from '../Shapes/AbstractShape';

export default class HalfCircleConfiguration implements ShapeConfigurationInterface {
	public hasNewValidators = true;

	get_dimension_keys(): string[] {
		return [
			'diameter',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		const shortest_side = maximum_rectangle.get_shortest_side();
		const longest_side = maximum_rectangle.get_longest_side();

		// Get the minimum of the longest side and the shortest side multiplied by 2
		return {
			diameter: new Length(Math.min(longest_side.in_mm(), shortest_side.multiply(2).in_mm())),
		};
	}

	get_minimum_dimensions( minimum: number ): Record<string, Length>|null {
		return {
			diameter: Length.from_cm(minimum),
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			diameter: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_new_validators( instance: AbstractShape, minimum: number, maximums: Record<string, Length> ): ValidatorInterface[] {
		return [
			new MaximumDecimalPoints( {
				field: 'half-circle-diameter',
				dimension: 'diameter',
				decimalPoints: 1,
				instance,
			} ),
			new MinimumValue( {
				field: 'half-circle-diameter',
				dimension: 'diameter',
				minimum: minimum * 2, // multiply minimum diameter with 2 so minimum height is correct
				instance,
			} ),
			new MaximumValue( {
				field: 'half-circle-diameter',
				dimension: 'diameter',
				instance,
				maximums,
			} ),
		];
	}

	get_cutout_validators(): ValidatorInterface[] {
		return [];
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
